import { useFilterStore } from "@faire/deprecated-retailer-visitor-shared/components/Filters/useFilterStore";
import { useGetItemsPerRowResponsive } from "@faire/deprecated-retailer-visitor-shared/components/SearchProducts/utils";
import { useSettingEnableLoggedOutDiscoverStoreTypeSection } from "@faire/deprecated-retailer-visitor-shared/settings/useSettingEnableLoggedOutDiscoverStoreTypeSection";
import { TOP_PRODUCTS_COUNT } from "@faire/deprecated-retailer-visitor-shared/views/search-v2/__internal__/LazySearchPage/__internal__/SearchPage/__internal__/SearchPageHeaderAndResults/__internal__/DiscoverPageSectionalDesign";
import { SearchPageExactProductResults } from "@faire/deprecated-retailer-visitor-shared/views/search-v2/__internal__/LazySearchPage/__internal__/SearchPage/__internal__/SearchPageHeaderAndResults/__internal__/SearchPageResults/__internal__/SearchPageProductResults/__internal__/SearchPageExactProductResults/SearchPageExactProductResults";
import { useSearchPageSlicedProducts } from "@faire/deprecated-retailer-visitor-shared/views/search-v2/__internal__/LazySearchPage/__internal__/SearchPage/__internal__/useSearchPageSlicedProducts";
import { useSearchPageIrrelevantProducts } from "@faire/deprecated-retailer-visitor-shared/views/search-v2/__internal__/LazySearchPage/__internal__/SearchPage/DataFetching/Products/useSearchPageIrrelevantProducts";
import { useSearchPageOrganicRelevanceClassification } from "@faire/deprecated-retailer-visitor-shared/views/search-v2/__internal__/LazySearchPage/__internal__/SearchPage/DataFetching/Products/useSearchPageorganicRelevanceClassification";
import { useDiscoverPageShouldShowTopProducts } from "@faire/deprecated-retailer-visitor-shared/views/search-v2/util/useDiscoverPageShouldShowTopProducts";
import { IThreeVariantXP } from "@faire/web-api--source/indigofair/settings/IThreeVariantXP";
import { useTraceComponentRender } from "@faire/web/common/tracing/useTraceComponentRender";
import { Spacer } from "@faire/web/slate/spacing";
import { useResponsiveValue } from "@faire/web/ui/hooks/useResponsiveValue";
import React from "react";

interface IProps {
  title: string;
  searchPageLoadTimingRef?: React.Ref<HTMLDivElement>;
}

export const SearchPageProductResults: React.FC<IProps> = ({
  title,
  searchPageLoadTimingRef,
}) => {
  useTraceComponentRender("SearchPageProductResults");

  const products = useSearchPageSlicedProducts();
  const irrelevantProducts = useSearchPageIrrelevantProducts();
  const organicRelevanceClassification =
    useSearchPageOrganicRelevanceClassification();

  const shouldShowTopProducts = useDiscoverPageShouldShowTopProducts();
  const storeTypeSectionVariant =
    useSettingEnableLoggedOutDiscoverStoreTypeSection();
  const {
    data: { isSideBarVisible },
  } = useFilterStore(["isSideBarVisible"]);

  const itemsPerRowResponsive = useGetItemsPerRowResponsive(isSideBarVisible);
  const itemsPerRow = useResponsiveValue(itemsPerRowResponsive);
  let remainingProducts = products;
  // The sectional design will take priority on identifying the top products.
  if (shouldShowTopProducts) {
    remainingProducts = products?.slice(TOP_PRODUCTS_COUNT);
  } else if (storeTypeSectionVariant === IThreeVariantXP.Bucket.VARIANT_2) {
    remainingProducts = products?.slice(itemsPerRow);
  }

  return (
    <>
      <SearchPageExactProductResults
        title={title}
        products={remainingProducts}
        irrelevantProducts={irrelevantProducts}
        organicRelevanceClassification={organicRelevanceClassification}
        searchPageLoadTimingRef={searchPageLoadTimingRef}
      />
      <Spacer height="1x" />
    </>
  );
};
